function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var NewGameOverlayTemplate = require('./new-game.template');
var LibraryOverlay = require('./library');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var NewGameOverlay = /*#__PURE__*/function () {
  function NewGameOverlay(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, NewGameOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.library_overlay = new LibraryOverlay(app, mod);
    this.file = null;
    this.file_name = '';
    this.busy = false;
  }
  return _createClass(NewGameOverlay, [{
    key: "render",
    value: function render() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.busy = false;
      this.file = opts.file || null;
      this.file_name = opts.file_name || 'Selected ROM';
      this.overlay.show(NewGameOverlayTemplate());
      this.attach_events();
    }
  }, {
    key: "set_busy",
    value: function set_busy() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Preparing…';
      this.busy = true;
      var root = document.querySelector('.nwasm-new-game');
      var state = root === null || root === void 0 ? void 0 : root.querySelector('.state');
      var status = root === null || root === void 0 ? void 0 : root.querySelector('.state .status');
      var choices = root === null || root === void 0 ? void 0 : root.querySelector('.choices');
      if (choices) {
        choices.hidden = true;
      }
      if (state) {
        state.hidden = false;
      }
      if (status) {
        status.textContent = message;
      }
    }

    //
    // Double-rAF + short timeout: give the browser a real chance to paint before
    // CPU-bound emulator init freezes the main thread.
    //
  }, {
    key: "wait_for_paint",
    value: function () {
      var _wait_for_paint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return new Promise(function (resolve) {
                requestAnimationFrame(function () {
                  requestAnimationFrame(resolve);
                });
              });
            case 1:
              _context.n = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 50);
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function wait_for_paint() {
        return _wait_for_paint.apply(this, arguments);
      }
      return wait_for_paint;
    }()
  }, {
    key: "attach_events",
    value: function attach_events() {
      var _this = this;
      var root = document.querySelector('.nwasm-new-game');
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-action="play"]').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          _this.play_game();
        };
      });
      root.querySelectorAll('[data-action="library"]').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          _this.open_library();
        };
      });
    }
  }, {
    key: "play_game",
    value: function () {
      var _play_game = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var mod, a, ab;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(this.busy || !this.file)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              mod = this.mod;
              if (mod.is_nwasm_page()) {
                _context2.n = 3;
                break;
              }
              this.set_busy('Preparing emulator…');
              _context2.n = 2;
              return this.wait_for_paint();
            case 2:
              this.overlay.hide();
              mod.queueEphemeralRomFromArcade(this.file, this.file_name);
              return _context2.a(2);
            case 3:
              this.set_busy('Preparing emulator…');
              _context2.n = 4;
              return this.wait_for_paint();
            case 4:
              this.overlay.hide();
              a = Buffer.from(this.file, 'binary').toString('base64');
              ab = mod.convertBase64ToByteArray(a);
              _context2.n = 5;
              return this.wait_for_paint();
            case 5:
              _context2.n = 6;
              return mod.playEphemeralRom(ab, this.file_name, this.file);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function play_game() {
        return _play_game.apply(this, arguments);
      }
      return play_game;
    }()
  }, {
    key: "open_library",
    value: function open_library() {
      if (this.busy || !this.file) {
        return;
      }
      this.overlay.hide();
      this.library_overlay.render({
        file: this.file,
        file_name: this.file_name
      });
    }
  }]);
}();
module.exports = NewGameOverlay;